export default "__VITE_ASSET__BWp_a8SW__"